import { getCollection, getCollectionCount, saveCollection } from './Collection';

const storedVersion = parseInt(localStorage.getItem('version'), 10) ?? -1;
const currentVersion = 1;

const upgrade = () => {
	if (storedVersion < currentVersion) {

		// Delete collection from old beta version
		if (getCollectionCount() > 0 && 'petId' in getCollection()[0]) {
			saveCollection([]);
		}
	}

	localStorage.setItem('version', `${currentVersion}`);
}

export default upgrade;
